import axios from "axios";
import { Base_Uri } from "../Constant/BaseUri";
import { db } from "../DB/db.js";

export const bootstrapProducts = async () => {
  let page = 1;
  let hasNext = true;
   let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

  while (hasNext) {
    const res = await axios.get(`${Base_Uri}sync/bootstrap/products?page=${page}`,{headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },});

    await db.products.bulkPut(res.data.products);
    await db.customers.bulkPut(res.data.customers);

    hasNext = res.data.hasNext;
    page++;
  }
// localStorage.setItem("bootstrapped", "true");
  localStorage.setItem("lastProductSyncAt", new Date().toISOString());
};